// src/redux/slices/apiSlice.js

import { createSlice } from '@reduxjs/toolkit';

const apiSlice = createSlice({
    name: 'loader',
    initialState: {
      loaders: {}
    },
    reducers: {
      setLoading(state, action) {
        const { apiName, isLoading } = action.payload;
        state.loaders[apiName] = isLoading;
      },
      clearLoaders(state) {
        state.loaders = {};
      }
    }
  });
  
  export const { setLoading, clearLoaders } = apiSlice.actions;

export default apiSlice.reducer;
